// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.SchedulingPreferencesResponse */
/* istanbul ignore next */
@GandalfModel
export class SchedulingPreferencesResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	fridayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfProperty({ designType: String })
	generalNote!: string | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	mondayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	saturdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesScheduleRisk)
	@GandalfProperty({ designType: constants.SchedulingPreferencesScheduleRisk })
	scheduleRisk!: constants.SchedulingPreferencesScheduleRisk | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	sundayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	thursdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	tuesdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	wednesdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

}
